import { render, staticRenderFns } from "./Totalizadores.vue?vue&type=template&id=200029c7&scoped=true&"
import script from "./Totalizadores.vue?vue&type=script&lang=js&"
export * from "./Totalizadores.vue?vue&type=script&lang=js&"
import style0 from "./Totalizadores.vue?vue&type=style&index=0&id=200029c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200029c7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VProgressCircular})
